import { type PropsWithChildren } from "react";

export const Cluster = ({ visible, children }: PropsWithChildren<{ visible: boolean }>) =>
  visible ? <>{children}</> : null;
